import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';

import Select from '../ui/Select';
import ApplicationContext from '../ApplicationContext';
import { ComboParamsBase, FmsComboType } from '../fms.core/constants';
import { JobNames } from '../framework.core/JobNames';
import _ from 'lodash';

function ContainerTypeDropDown({
  value,
  onChange = () => {},
  disabled = false,
  selectId = undefined,
  isShort = false,
  onEnterSameValue,
  jobName = '',
  maxLength = undefined,
  name  = undefined,
} : {
  value: string|null,
  onChange?: (x:string|null) => void,
  disabled?: boolean,
  selectId: string|undefined,
  isShort?: boolean,
  onEnterSameValue?: VoidFunction,
  jobName:string,
  maxLength:number|undefined,
  name?: string|undefined,
}
) {
  const appContext = useContext(ApplicationContext);

  const [data, setData] = useState<Array<any>>([]);

  async function fetchData(api:any) {
    //const data = await api.getCodesOceanContainerTypes();
    //setData(data);
    var base = new ComboParamsBase();
    base.comboType = FmsComboType.CntrType;
    const data = await api.loadCodeData([base]);
    if (data && data.length > 0) {
      setData(data[0].items);
    }
  }

  function getWidth(jobName : string) {
    let tempWidth = '100px';
    switch(jobName){
      case JobNames.OIMbl:
        tempWidth = '90px'; 
        break;
      case JobNames.OEMbl:
      case JobNames.FlexiTank:
        tempWidth = '80px'; 
        break;
      case JobNames.OtherOP:
        tempWidth = '50px'; 
        break;
      default:
        tempWidth = '100px'; 
        break;
    }
    return tempWidth;
  }


  function handleChange(e:React.ChangeEvent<HTMLInputElement>) {
    onChange(e.target.value || null);
  }

  useEffect(() => {
    fetchData(appContext.api);
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const displayData = isShort ? [
    {value: '', label: '', activeLabel: '' },
    ...data.map(x => ({ value: x.text, label: !_.isEmpty(x.value) ? `${x.text} ${x.value}` : x.text, activeLabel: x.text }))
  ] : [
    {value: '', label: '', activeLabel: '' },
    ...data.map(x => ({ value: x.text, label: x.text, activeLabel: x.text }))
  ];

  return (
    <Select
      name={name}
      maxLength={maxLength}
      selectId={selectId}
      value={value || ''}
      onChange={handleChange}
      disabled={disabled}
      items={displayData}
      selectWidth={getWidth(jobName)}
      onEnterSameValue={onEnterSameValue}
    />
  );
}

ContainerTypeDropDown.defaultProps = {
  onChange: () => {},
  disabled: false,
};

ContainerTypeDropDown.propTypes = {
  selectId: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onEnterSameValue: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
};

export default React.memo(ContainerTypeDropDown);
